import { AxiosResponse } from 'axios'
import { useApiClient, getMediaBaseEndpoint } from '@/hooks'
import { unwrapErrorResponse } from '@/utils'
import { MediaType, ModelsWithMedia } from '@/types'

type UseDeleteMediaParams = {
  modelKey: ModelsWithMedia
}

type UseDeleteMediaPayload = {
  entityId: number
  mediaId: number
  mediaType: MediaType
}

export const useDeleteEntityMedia = ({
  modelKey,
}: UseDeleteMediaParams): ((
  data: UseDeleteMediaPayload
) => Promise<AxiosResponse<void>>) => {
  const client = useApiClient()

  return ({ mediaId, entityId, mediaType }) =>
    client
      .delete(
        `${getMediaBaseEndpoint(modelKey)}/${entityId}/${mediaType}/${mediaId}/`
      )
      .then((response) => response)
      .catch(unwrapErrorResponse)
}
